export enum Status {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  BROKEN = "BROKEN",
  EDITED = "EDITED",
  MODIFIED = "MODIFIED",
}

const colors: { [key in Status]: { fg: string; bg: string } } = {
  ACTIVE: { fg: "bg-emerald-400", bg: "bg-emerald-100" },
  INACTIVE: { fg: "bg-gray-400", bg: "bg-gray-100" },
  BROKEN: { fg: "bg-red-400", bg: "bg-red-100" },
  EDITED: { fg: "bg-blue-400", bg: "bg-blue-100" },
  MODIFIED: { fg: "bg-blue-400", bg: "bg-blue-100" },
};

type StatusLightProps = {
  status: Status;
};
const StatusLight = ({ status }: StatusLightProps) => {
  return (
    <span
      className={`h-4 w-4 mr-2 rounded-full inline-flex items-center justify-center ${colors[status].bg}`}
      aria-hidden="true"
    >
      <span className={`h-2 w-2 rounded-full ${colors[status].fg}`} />
    </span>
  );
};

export default StatusLight;
